import { render, staticRenderFns } from "./helang-pickerColor.vue?vue&type=template&id=572886e9&scoped=true&"
import script from "./helang-pickerColor.vue?vue&type=script&lang=js&"
export * from "./helang-pickerColor.vue?vue&type=script&lang=js&"
import style0 from "./helang-pickerColor.vue?vue&type=style&index=0&id=572886e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572886e9",
  null
  
)

export default component.exports